<div class="alert" [ngClass]="alertType()">
  <img [src]="img()" [alt]="alertType()" [ngClass]="iconType()" />
  <span class="message">{{ message() }}</span>
</div>
